import { Injectable } from '@angular/core';

import { ConfigParserService } from '../../shared/services/config-parser.service';

export interface AppTilesConfig {
    coreAppIds: Array<string>;
    mobileAppIds: Array<string>;
    myAccountUrl: string;
    resources: AppTilesResources;
    segmentSpecificAppIds: Array<string>;
}

interface AppTilesResources {
    AppTilesHeader: string;
    AppTilesListLandmarkAriaLabel: string;
    ExploreYourAppsAriaLabel: string;
    ExploreYourAppsText: string;
    MyAccountConsumerLinkText: string;
    ProvisioningAlertText: string;
    ProvisioningTileText: string;
    ShowAllOnlineApps: string;
    ShowAllOnlineAppsAriaLabel: string;
    ShowLessOnlineApps: string;
    ShowLessOnlineAppsAriaLabel: string;
    ShowLessAppTiles: string;
    ShowLessAppTilesAriaLabel: string;
    ShowMoreAppTiles: string;
    ShowMoreAppTilesAriaLabel: string;
}

@Injectable({
    providedIn: 'root'
})
export class AppTilesConfigService {
    public readonly config: AppTilesConfig;

    constructor(
        configParserService: ConfigParserService
    ) {
        // Initialize to default values if there was failure to read user context from page response
        this.config = configParserService.parse<AppTilesConfig>('appTilesConfig') || {
            coreAppIds: [],
            mobileAppIds: [],
            myAccountUrl: null,
            resources: null,
            segmentSpecificAppIds: []
        };
    }
}
